import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { THEME_LOOKUPS_RESOURCE, UPDATE_THEME_LOOKUP_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

const UpdateThemeLookupService = ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_THEME_LOOKUP_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.themeLookups(id),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: THEME_LOOKUPS_RESOURCE,
            idProp: 'id',
            id,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateThemeLookupFailed'),
            onSuccessMessage: t('updateThemeLookupSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UpdateThemeLookupService;
